import React from 'react';
import {injectIntl} from 'react-intl';
import Icon from '@Components/Icon';

const NoticeInPage = ({intl, content, noIntl = false, type = 'informative', extraClasses}) => {
  const icon = type === 'positive' ? 'check' : type === 'informative' ? 'info' : 'warning';

  return (
    <div className={`notice-in-page notice-in-page--${type} ${extraClasses}`}>
      <span className="icon icon--inline">
        <Icon type={icon} />
      </span>
      <span className="notice-in-page__body-copy" dangerouslySetInnerHTML={{__html: noIntl ? content : intl.formatMessage({id: content})}}/>
    </div>
  );
};

export default injectIntl(NoticeInPage);
